import { Tree } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { PERMISSION_LIST } from "@static/PERMISSION_LIST";
import { filterPermissions } from "@utils/filterPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const SectionTree = styled.div`
  height: calc(100% - 58px);
  overflow-y: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormEdit = ({
  setDataList = () => undefined,
  setIsModalVisible,
  categoryCustomerId,
  selectedData,
  setSelectedData,
  userType,
}) => {
  const id = _.get(selectedData, ["id"]);
  const name = _.get(selectedData, ["name"]);
  const permissions = _.get(selectedData, ["permissions"]);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      name: name,
    },
  });
  const filteredPermissions = filterPermissions({
    permissions: PERMISSION_LIST,
    userType,
  });
  const [checkedPermissions, setCheckedPermissions] = useState(permissions);

  const onHandleEdit = async (data) => {
    const name = _.get(data, ["name"]);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/roles-update",
      isAuth: true,
      data: {
        id,
        name,
        permissions: checkedPermissions,
        category_customer_id: null,
      },
    });
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      const updateData = _.chain(results)
        .thru((item) => {
          return {
            id: _.get(item, ["id"]),
            name: _.get(item, ["name"]),
            permissions: JSON.parse(_.get(item, ["permissions"])),
          };
        })
        .value();

      toast.success("Update Role Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      setSelectedData(null);
      setDataList((prev) => {
        const updateDataList = _.map(prev, (item) => {
          return _.get(item, ["id"]) ===
            _.chain(results).get(["id"]).toInteger().value()
            ? { ...item, ...updateData }
            : item;
        });
        return updateDataList;
      });
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleEdit)} autoComplete="off">
      <Line />
      <Controller
        name="name"
        control={control}
        rules={_.get(VALIDATE_RULES, ["required"])}
        render={({ field, fieldState: { error } }) => (
          <div>
            <Text
              color={COLOR_DARK}
              fontSize="14px"
              style={{ marginBottom: 4, marginLeft: 4 }}
            >
              Name
            </Text>
            <StyledInput {...field} size="large" placeholder="name" />
            <ErrorValidate justify="start" error={error} />
          </div>
        )}
      />
      <SectionTree>
        <Tree
          treeData={filteredPermissions}
          checkable
          defaultExpandAll
          onCheck={(e) => setCheckedPermissions(_.get(e, ["checked"]))}
          checkedKeys={checkedPermissions}
          checkStrictly={true}
        />
      </SectionTree>
      <ButtonContainer>
        <Button
          type="submit"
          color={COLOR_GREEN}
          fontColor={COLOR_WHITE}
          fontSize="16px"
          padding="5px 20px"
        >
          Save
        </Button>
      </ButtonContainer>
    </FormContainer>
  );
};
